import classNames from 'classnames';
import ZpButton from 'components/zpButton';
import { useSignUp } from 'hooks';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import React, { useState } from 'react';
import { updateUserProfile } from 'services/userService';
import { dispatchCloseGatedSignupPopup } from 'store/modals/actions';
import { updateUser } from 'store/user/actions';
import { JobTitle, Location } from 'types';
import { addUserGroupToData, validateEmail } from 'utils';
import { SIGN_UP_STATUSES } from 'utils/constant';
import classes from './index.module.css';
import _isEmpty from 'lodash/isEmpty';

const EmailBox = ({ buttonContent = null }) => {
  const [email, setEmail] = useState('');
  const [validationError, setValidationError] = useState('');
  const dispatch = useAppDispatch();
  const signUp = useSignUp();
  const criteria = useAppSelector((state) => state.locals.criteria);

  const onSignup = (e: React.KeyboardEvent | React.FormEvent) => {
    e.preventDefault();
    if (validateEmail(email)) {
      setValidationError('');
      const data = {
        email,
        source: 'partialGate',
        signUpWorkflow: true,
        pageCategory: window.pageCategory,
        ...(criteria.title ? { jobTitle: criteria.title } : {}),
      };

      addUserGroupToData(data);

      signUp.withEmail(data, async (_: any, status: string) => {
        if (status === SIGN_UP_STATUSES.SUCCESS) {
          dispatch(updateUser());
          dispatch(dispatchCloseGatedSignupPopup());
          const payload = {} as { titles: JobTitle[]; location: Location[] };
          if (criteria.title) {
            payload.titles = [
              {
                originalSearch: criteria.title,
                normalizedTitle: criteria.title,
              },
            ];
          }
          if (criteria.geoState || criteria.geoStateCode) {
            payload.location = [
              { city: criteria.geoCity, state: criteria.geoStateCode || criteria.geoState },
            ];
          }
          if (!_isEmpty(payload)) {
            try {
              await updateUserProfile(payload);
            } catch (err) {
              console.error(err);
            }
          }
        } else if (status === SIGN_UP_STATUSES.EXIST) {
          setValidationError('Account already exists, please sign in using this email.');
        } else {
          setValidationError('Error occurred while registering the user.');
        }
      });
    } else {
      setValidationError('Email is invalid. Please try again with a valid email.');
    }
  };

  return (
    <div className="w-100">
      <form className="d-flex flex-column flex-md-row" onSubmit={onSignup}>
        <div className={classes.input}>
          <input
            value={email}
            placeholder="Your Email"
            className="mx-2"
            onChange={(e) => {
              setValidationError('');
              setEmail(e.target.value);
            }}
          />
        </div>
        {buttonContent ? (
          <button type="submit" className={classNames(classes.btn, classes.iconButton)}>
            {buttonContent}
          </button>
        ) : (
          <ZpButton type="submit" className={classNames('openSansBlackBold', classes.btn)}>
            Sign Up
          </ZpButton>
        )}
      </form>
      {validationError && <div className="mt-1 error-message">{validationError}</div>}
    </div>
  );
};

export default EmailBox;
